<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row col-lg-6 col-sm-6 my-auto">
            <a
                class="pr-2 text-dark cursor-pointer"
                v-on:click="$router.push('/setting')"
                ><span class="font-24 mr-2"
                  ><img src="/images/back-arrow.svg" width="18"
                /></span>
              </a>
            <h4 class="mb-0 lg-bld">Contact Us</h4>
          </div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-2">
            <div class="row">
              <div class="col-lg-6 col-sm-6 form-group row">
                <div class="has-search ml-3">
                  <i class="fa fa-search" style="position: absolute; margin: 10px" aria-hidden="true"></i>
                  <input type="text" class="form-control" v-on:keyup.enter="getList(0)" placeholder="Search"
                    v-model="searchObj.keyword" />
                </div>
                <a class="fill-btn btn-style cursor-pointer ml-3" v-on:click="getList(0)">Search</a>
                <a class="fill-btn btn-style cursor-pointer" v-on:click="resetFilter"
                  v-show="searchObj.keyword">Reset</a>
              </div>
              <div style="cursor: pointer"
                class="col-lg-6 col-sm-6 txt-right form-group">
                <a class="fill-btn cursor-pointer"
                  v-on:click="$router.push('/add-contact')">+ Add</a>
              </div>
            </div>
            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <div class="dataTables_wrapper dt-bootstrap4">
                    <table class="table table-striped table-bordered dataTable" style="width: 100%" role="grid"
                      aria-describedby="example_info">
                      <thead>
                        <tr role="row">
                          <th>Sr. No.</th>
                          <th class="sorting" id="id-branch_name" v-on:click="sorting('branch_name', 'id-branch_name')">Branch Name</th>
                          <th class="sorting" id="id-email" v-on:click="sorting('email', 'id-email')">Email</th>
                          <th class="sorting" id="id-mobile" v-on:click="sorting('mobile', 'id-mobile')">Mobile Number</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody v-show="!loader">
                        <tr v-for="(data, index) in list" :key="index">
                          <td style="text-align:left;">
                            {{
                                ($refs.listPagination.currentPage - 1) * 10 +
                                index +
                                1
                            }}
                          </td>
                          <td style="text-align:left;">{{ data.branch_name ?data.branch_name:"-" }}</td>
                          <td style="text-align:left;">{{ data.email ? data.email : "-" }}</td>
                          <td style="text-align:left;">{{ data.phone ? data.phone :"-" }}</td>
                          <td>
                            <a class="fill-btn btn-style cursor-pointer"
                              v-on:click="$router.push('/edit-contact/' + data.uuid)"
                             >Edit</a>
                            <a class="fill-btn btn-style cursor-pointer" v-on:click="showDeletePopup(data)"
                            >Delete</a>
                            <div class="custom-control custom-switch d-inline mr-2">
                              <input type="checkbox" class="custom-control-input" v-model="data.status"
                                true-value="ACTIVE" false-value="INACTIVE" :id="'status_' + data.uuid"
                                @change="checkStatus(data.uuid)" />
                              <label class="custom-control-label" :for="'status_' + data.uuid"></label>
                            </div>
                            <!-- <div class="custom-control custom-switch  ms-5">
                            <input
                              class="custom-control-input"
                              type="checkbox"
                              id="customSwitch1"
                              true-value="ACTIVE"
                              false-value="INACTIVE"
                              @change="statusUpdated()"
                              v-model="data.status"
                            />
                            <label
                              class="custom-control-label"
                              for="customSwitch1"
                            >
                            </label>
                          </div> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-0 mb-4">
                  <div class="col-lg-12 mt-5 text-center">
                    <div class="page-bottom-pagination text-right">
                      <Pagination @page-change="pageChange" @items-per-page-change="itemsPerPageChange"
                        ref="listPagination" />
                    </div>
                  </div>
                </div>
                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
        <div class="text-center" style="margin-top: 20%" v-show="accessObject?.is_view == 0 || isShowAccessDeniedMessage">
          <h3>You do not have access to view admin</h3>
        </div>
      </div>
    </div>
    <DeleteModal @remove="deleteRecord($event)" ref="deleteModal" />
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import DeleteModal from "@/components/DeleteModal";
import Pagination from "@/components/Pagination";

export default {
  name: "ContactUs",
  components: {
    ErrorComponent,
    DeleteModal,
    Pagination,
  },
  data() {
    return {
      // accessObject: this.$helperService.getAccessLevel("Manage Admins"),
      loader: true,
      // isShowAccessDeniedMessage: false,
      searchObj: {
        keyword: '',
      },
      offset: -1,
      list: [],
    };
  },
  mounted() {
    // if (!this.accessObject) {
    //   this.isShowAccessDeniedMessage = true;
    //   this.$router.push("/access-denied");
    //   return;
    // }
    this.$helperService.showMenu('true')
    this.getList(0);
  },
  methods: {
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateFormLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
        _action: "/contact-us/pagination/list",
          _body: this.searchObj
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No Branch Available");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        });
    },
     checkStatus(uuid) {
      var status_value = "";
      var status = {};
      for (var s = 0; s < this.list.length; s++) {
        if (uuid == this.list[s].uuid) {
          if (document.getElementById("status_" + uuid).checked == true) {
            status_value = "ACTIVE";
          } else {
            status_value = "INACTIVE";
          }
        }
      }
      status["status"] = status_value;
      status["uuid"] = uuid;
      this.$api
        .putAPI({
          _action: "/contact-us/update-status",
          _body: status,
        })
        .then(() => {
          this.$notify({
            type: "success",
            text: "Contact us status updated successfully",
          });
          this.getList(0);
        })
        .catch(() => { });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id)
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = ''
      this.getList(0);
    },
    showDeletePopup(data) {
      this.$refs.deleteModal.showModal(
        "Delete Contact",
        "Are you sure you want to delete " + data.branch_name,
        data
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$api
        .putAPI({
          _action: "/contact-us/delete/" + detail.uuid,
        })
        .then((res) => {
          if (res) {
            this.$refs.deleteModal.closeModal();
            this.getList();
            this.$notify({
              type: "success",
              text: res.message,
            });
          }
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },
  },
};
</script>